import React from 'react';
import { Rocket } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-white border-t border-slate-200 pt-16 pb-8" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        {/* Final CTA */}
        <div className="bg-orange-500 rounded-2xl p-8 md:p-12 text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4 tracking-tighter" data-id="element-37">
            Klaar om slim te oefenen?
          </h2>
          <p className="text-orange-50 text-lg mb-8 max-w-2xl mx-auto" data-id="element-38">
            Probeer Meester djay gratis en ontdek hoe adaptief leren het
            verschil maakt voor elke leerling.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-39">
            <a href="https://demo.meesterdjay.nl" target="_blank" rel="noopener noreferrer" className="bg-white text-orange-600 hover:bg-orange-50 px-8 py-3.5 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-40">
              Start de demo
            </a>
            <a href="mailto:mick@mvlcreative.com" className="bg-orange-600 text-white hover:bg-orange-700 px-8 py-3.5 rounded-lg font-bold text-base transition-colors" data-id="element-41">
              Neem contact op
            </a>
          </div>
        </div>

        {/* Footer Links & Info */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12" data-id="element-42">
          <div className="md:col-span-2" data-id="element-43">
            <div className="flex items-center gap-2.5 mb-4" data-id="element-44">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center text-white font-bold text-sm" data-id="element-45">
                md
              </div>
              <span className="text-lg font-extrabold tracking-tight text-slate-950" data-id="element-46">
                Meester djay
              </span>
            </div>
            <p className="text-slate-500 text-sm max-w-sm mb-6 leading-relaxed" data-id="element-47">
              Het intelligente leerplatform dat zich aanpast aan het niveau van
              elk kind. Voor groep 6, 7 en 8.
            </p>
            <div className="inline-flex items-center gap-2 bg-slate-50 text-slate-600 px-3 py-1.5 rounded-md text-xs font-bold border border-slate-200" data-id="element-48">
              <Rocket className="w-3.5 h-3.5" data-id="element-49" />
              Versie 3.0 RC — React + TypeScript
            </div>
          </div>

          <div data-id="element-50">
            <h4 className="font-bold text-slate-950 mb-4 text-xs uppercase tracking-wider" data-id="element-51">
              Platform
            </h4>
            <ul className="space-y-3" data-id="element-52">
              <li data-id="element-53">
                <a href="#vakken" className="text-sm font-medium text-slate-500 hover:text-orange-500 transition-colors" data-id="element-54">
                  Vakgebieden
                </a>
              </li>
              <li data-id="element-55">
                <a href="#hoe-het-werkt" className="text-sm font-medium text-slate-500 hover:text-orange-500 transition-colors" data-id="element-56">
                  Hoe het werkt
                </a>
              </li>
              <li data-id="element-57">
                <a href="#faq" className="text-sm font-medium text-slate-500 hover:text-orange-500 transition-colors" data-id="element-58">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-59">
            <h4 className="font-bold text-slate-950 mb-4 text-xs uppercase tracking-wider" data-id="element-60">
              Organisatie
            </h4>
            <ul className="space-y-3" data-id="element-61">
              <li data-id="element-62">
                <a href="#" className="text-sm font-medium text-slate-500 hover:text-orange-500 transition-colors" data-id="element-63">
                  Over ons
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="text-sm font-medium text-slate-500 hover:text-orange-500 transition-colors" data-id="element-65">
                  Voor scholen
                </a>
              </li>
              <li data-id="element-66">
                <a href="#investeerders" className="text-sm font-medium text-slate-500 hover:text-orange-500 transition-colors" data-id="element-67">
                  Voor investeerders
                </a>
              </li>
              <li data-id="element-68">
                <a href="mailto:contact@meesterdjay.nl" className="text-sm font-medium text-slate-500 hover:text-orange-500 transition-colors" data-id="element-69">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-70">
          <p className="text-slate-500 text-xs font-medium" data-id="element-71">
            © 2026 Meester djay — Adaptief leren voor het Nederlandse
            basisonderwijs
          </p>
          <p className="text-slate-500 text-xs font-bold" data-id="element-72">
            Gemaakt in Nederland 🇳🇱
          </p>
        </div>
      </div>
    </footer>;
}